import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    token: null,
    user: null,
    isLoggedIn: false,
    role: null,
    customer_id: null,
    isRehydrated: false, // new: signals when state is restored
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess: (state, action) => {
            const { token, user } = action.payload;
            state.token = token;
            state.user = user;
            state.isLoggedIn = true;
            state.role = user.user_type;
            state.customer_id = user.customer_id || null;
            state.isRehydrated = true;
        },
        logout: (state) => {
            state.token = null;
            state.user = null;
            state.isLoggedIn = false;
            state.role = null;
            state.customer_id = null;
            state.isRehydrated = true;
        },
        setRehydrated: (state) => {
            state.isRehydrated = true;
        },
    },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
